import { render, staticRenderFns } from "./speakers.vue?vue&type=template&id=288c5cfe&scoped=true&"
import script from "./speakers.vue?vue&type=script&lang=js&"
export * from "./speakers.vue?vue&type=script&lang=js&"
import style0 from "./speakers.vue?vue&type=style&index=0&id=288c5cfe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288c5cfe",
  null
  
)

export default component.exports